<template>
  <div class="navigation">
    <md-app md-waterfall md-mode="overlap">
      <slot name="header">
        <md-app-toolbar>
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <md-button
                class="md-icon-button"
                @click="toggleMenu"
                v-if="menuVisible"
              >
                <md-icon>menu</md-icon>
              </md-button>
              <span class="md-title">{{ $route.name }}</span>
            </div>

            <div class="md-toolbar-section-end" v-if="showAddButton">
              <md-button class="md-icon-button" @click="openAddModal">
                <md-icon>add</md-icon>
              </md-button>
            </div>
          </div>
        </md-app-toolbar>
      </slot>

      <md-app-drawer :md-active.sync="menuVisible" md-persistent="mini">
        <md-toolbar class="md-transparent" md-elevation="0">
          <img src="../assets/icon.png" />
        </md-toolbar>

        <md-list>
          <md-list-item v-if="!menuVisible" @click="toggleMenu">
            <md-icon>menu</md-icon>
            <span class="md-list-item-text">Home</span>
          </md-list-item>

          <div class="divider"></div>

          <md-list-item to="/home" exact>
            <md-icon>home</md-icon>
            <span class="md-list-item-text">Home</span>
          </md-list-item>

          <div class="divider"></div>

          <md-list-item to="/feedback" exact>
            <md-icon>comment</md-icon>
            <span class="md-list-item-text">Feedback</span>
          </md-list-item>

          <md-list-item to="/mood-feedback" exact>
            <md-icon>insert_emoticon</md-icon>
            <span class="md-list-item-text">Mood Feedback</span>
          </md-list-item>

          <template v-if="userRole === 'admin' || userRole === 'manager'">
            <div class="divider"></div>
            <md-list-item to="/groups" exact>
              <md-icon>people</md-icon>
              <span class="md-list-item-text">Groups</span>
            </md-list-item>
            <md-list-item to="/admin-users" exact>
              <md-icon>account_circle</md-icon>
              <span class="md-list-item-text">Admin Users</span>
            </md-list-item>
            <md-list-item to="/settings" exact>
              <md-icon>settings</md-icon>
              <span class="md-list-item-text">Settings</span>
            </md-list-item>
          </template>

          <div class="divider"></div>

          <md-list-item @click="logout">
            <md-icon>logout</md-icon>
            <span class="md-list-item-text">Logout</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content>
        <transition name="slide-fade" mode="out-in">
          <slot v-if="initialized"></slot>
          <v-skeleton-loader
            ref="skeleton"
            type="table"
            class="mx-auto"
            v-else
          ></v-skeleton-loader>
        </transition>
      </md-app-content>
    </md-app>

    <v-snackbar v-model="sbVisible" :timeout="snackbarDuration">
      {{ sbMessage }}
    </v-snackbar>
  </div>
</template>

<style scoped>
.navigation {
  height: 100%;
}
.navigation ul {
  padding-left: 0;
}
.md-app {
  height: 100%;
}

.md-drawer {
  width: 250px;
  max-width: calc(100vw - 125px);
}

.md-persistent ~ .md-app-container > .md-app-toolbar {
  padding-left: 90px;
}
.md-persistent.md-active ~ .md-app-container > .md-app-toolbar {
  padding-left: 20px;
}
.md-drawer.md-persistent-mini:not(.md-active) {
  transform: translate3D(0, 0, 0);
}

.md-drawer.md-theme-default {
  background: #161934;
  background-image: linear-gradient(160deg, #1b1f40 0%, #0c0e1c 100%);
}
.md-list.md-theme-default {
  background: transparent;
}
.md-list.md-theme-default .md-list-item-container {
  color: #fff;
  font-weight: bold;
}
.md-list-item-router.md-list-item-container.md-button-clean.router-link-exact-active.router-link-active {
  color: #92b48b;
}
.md-list.md-theme-default
  .md-list-item-container:not(.md-list-item-default):not(.md-list-item-expand):not([disabled]):hover {
  color: rgba(255, 255, 255, 0.7);
}
.md-icon.md-theme-default.md-icon-font {
  color: #fff;
}
.md-app.md-overlap .md-app-toolbar {
  background: #161934;
  background-image: linear-gradient(160deg, #2f3570 0%, #161934 100%);
}
.md-toolbar.md-theme-default .md-title,
.md-toolbar.md-theme-default .md-display-1,
.md-toolbar.md-theme-default .md-display-2 {
  color: #fff;
}
.md-toolbar img {
  width: 50%;
  margin-top: 20px;
  margin-left: 25%;
  border-radius: 5px;
}
.md-list-item-content > .md-icon:first-child {
  margin-right: 20px;
}

.space {
  flex: 1;
}
.divider {
  margin: 10px 20px;
  width: calc(100% - 40px);
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}

.md-app-content {
  padding-bottom: 70px;
}
</style>

<script>
import firebase from "firebase/app";
import { EventBus } from "../main";

import { mapState } from "vuex";

export default {
  name: "Navigation",
  data: () => ({
    menuVisible: false,
    snackbarVisible: false,
    snackbarMessage: null,
    snackbarDuration: 4000
  }),
  computed: {
    showAddButton: function() {
      let path = this.$route.path;
      return path == "/users";
    },
    ...mapState(["initialized", "userRole", "sbVisible", "sbMessage"])
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("/");
        });
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    openAddModal() {
      EventBus.$emit("openAddModal");
    },
    showSnackbar(message, duration = 4000) {
      this.snackbarMessage = message;
      this.snackbarDuration = duration;
      this.snackbarVisible = true;
    }
  },
  mounted() {
    EventBus.$on("showSnackbar", this.showSnackbar);
  },
  beforeDestroy() {
    EventBus.$off("showSnackbar");
  }
};
</script>
